export default {
    title: 'Bildungskonzept',

    downloadEducationalConcept: 'Bildungskonzept herunterladen',
    educationalConceptGoal: 'Bildungsziel',
    page: 'Seitenzahl im Bildungskonzept',
    pageOfSelectedEducationalConcept: 'Seitenzahl des ausgewählten Bildungsziels im Bildungskonzept',
}